import { render, staticRenderFns } from "./UsuariosAtivosPorLoja.vue?vue&type=template&id=c242dba4&scoped=true"
import script from "./UsuariosAtivosPorLoja.vue?vue&type=script&lang=js"
export * from "./UsuariosAtivosPorLoja.vue?vue&type=script&lang=js"
import style0 from "./UsuariosAtivosPorLoja.vue?vue&type=style&index=0&id=c242dba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c242dba4",
  null
  
)

export default component.exports